import { AmplifilesClient } from "./api-client";
import {
  CreateScriptChatResponseDto,
  GetActiveScriptChatResponseDto,
} from "@repo/api/voice-over";

export class VoiceOverApi {
  static async getActiveScriptChat(
    teamExternalId: string,
    videoExternalId: string,
  ): Promise<GetActiveScriptChatResponseDto> {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/video/${videoExternalId}/script-chat`,
    );

    return GetActiveScriptChatResponseDto.parse(response.data);
  }

  static async createScriptChat(
    teamExternalId: string,
    videoExternalId: string,
  ): Promise<CreateScriptChatResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/video/${videoExternalId}/script-chat`,
    );

    return CreateScriptChatResponseDto.parse(response.data);
  }

  static async sendMessage(
    teamExternalId: string,
    chatExternalId: string,
    message: string,
    signal?: AbortSignal,
  ): Promise<Response> {
    return AmplifilesClient.stream(
      `/team/${teamExternalId}/script-chat/${chatExternalId}/messages`,
      {
        method: "POST",
        body: JSON.stringify({ message }),
        signal,
      },
    );
  }
}
